// import main stylesheet
import './scss/index.scss';

// start scripts
import './scripts/main';
